<template>
    <div class="row g-0 login-container">
        <!-- Left Side (Form) -->
        <div class="col-lg-6 d-flex flex-column justify-content-center p-5 position-relative bg-white z-2">
            <div class="w-100 mx-auto" style="max-width: 450px;">
                <a href="/customer/login" class="text-decoration-none text-brown small mb-4 d-inline-block fw-bold"><i
                        class="bi bi-arrow-left me-2"></i> Back</a>

                <h1 class="text-brown fw-bold font-serif mb-3">Forgot Password?</h1>
                <p class="text-muted mb-5 small">Don't worry! It occurs. Please enter the email address linked with your
                    account.</p>

                <form @submit.prevent="submitForgot">
                    <div class="mb-5">
                        <input type="email" class="form-control rounded-3 py-2" v-model="email" placeholder="Enter your email" required :class="{ 'is-invalid': errors.email }">
                        <div class="invalid-feedback" v-if="errors.email">
                            {{ errors.email[0] }}
                        </div>
                    </div>

                    <button type="submit" class="btn btn-brown w-100 py-2 rounded-2 mb-4" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span v-else>Confirm</span>
                    </button>
                    
                    <div v-if="generalError" class="alert alert-danger mt-3 small">
                        {{ generalError }}
                    </div>
                    <div v-if="successMessage" class="alert alert-success mt-3 small">
                        {{ successMessage }}
                    </div>
                </form>
            </div>

            <div class="position-absolute bottom-0 start-0 w-100 text-muted xx-small text-center pb-4">
                All rights reserved to FIT..... 2025©
            </div>
        </div>

        <!-- Right Side (Visual) -->
        <div
            class="col-lg-6 position-relative d-none d-lg-block split-bg-right d-flex align-items-center justify-content-center overflow-hidden">
            <!-- Angled Divider -->
            <div
                style="position: absolute; top:0; left:0; width: 100%; height: 100%; background-color: transparent; pointer-events: none;">
                <div
                    style="position: absolute; top:0; left: -100px; width: 15vw; height: 100%; background: white; transform: skewX(-15deg); transform-origin: top;">
                </div>
            </div>

            <div class="position-relative text-center z-1 w-75">
                <div class="mb-5">
                    <h1 class="display-3 fw-bold text-brown font-serif">FR<br><span
                            class="h6 fw-normal inter-font letter-spacing-2">FEKRA</span></h1>
                </div>

                <div class="arch-image-container position-relative shadow-lg">
                    <img src="https://placehold.co/400x500/8D6E63/white?text=Living+Room"
                        class="w-100 h-100 object-fit-cover" alt="Interior">
                </div>

                <!-- Decorative +s -->
                <div class="position-absolute top-0 end-0 text-brown small lh-1 opacity-50 pe-4 mt-5">
                    + +<br>+ +<br>+ +
                </div>
                <div class="position-absolute bottom-0 start-0 text-brown small lh-1 opacity-50 ps-4 mb-5">
                    + +<br>+ +<br>+ +
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                email: '',
                loading: false,
                errors: {},
                generalError: '',
                successMessage: ''
            }
        },
        mounted() {
            console.log('ForgotPassword Component mounted.')
        },
        methods: {
            submitForgot() {
                this.loading = true;
                this.errors = {};
                this.generalError = '';
                this.successMessage = '';

                axios.post('/customer/forgot-password-submit', {
                    email: this.email
                })
                .then(response => {
                    this.successMessage = response.data.message;
                    // Optional: redirect after short delay or immediately
                    setTimeout(() => {
                         window.location.href = response.data.redirect || '/customer/verify-otp';
                    }, 1000);
                })
                .catch(error => {
                    this.loading = false;
                    if (error.response && error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    } else if (error.response && error.response.data && error.response.data.message) {
                        this.generalError = error.response.data.message;
                    } else {
                        this.generalError = 'An error occurred. Please try again.';
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .split-bg-right {
        background-image: url('https://placehold.co/1920x1080/F9F5F0/F9F5F0?text=Wood+Texture');
        background-size: cover;
        background-position: center;
        position: relative;
    }

    .login-container {
        min-height: 100vh;
        overflow: hidden;
    }

    .arch-image-container {
        border-top-left-radius: 50% 20%;
        border-top-right-radius: 50% 20%;
        overflow: hidden;
        height: 400px;
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }
</style>
